import { axios } from "@/libraries/axios";
import type {
	BulletinGroup,
	BulletinsSearchSchema,
	GetBulletinGroupsResponse,
	GetBulletinGroupsSubscribedResponse,
} from "@/types";

class BulletinService {
	async bulletins<T = unknown>(params: Partial<BulletinsSearchSchema>) {
		try {
			const res = await axios.get<T>("/api/v1/bulletins", {
				params: {
					page: params?.page ?? 1,
					limit: params?.limit ?? 10,
					...params,
				},
			});
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	async groups() {
		try {
			const res = await axios.get<GetBulletinGroupsResponse>(
				"/api/v1/bulletins/groups",
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	async subscribedGroups() {
		try {
			const res = await axios.get<GetBulletinGroupsSubscribedResponse>(
				"/api/v1/bulletins/subscribed_groups",
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	async createSubscribedGroup(bulletinIds: BulletinGroup["id"][]) {
		try {
			const res = await axios.post("/api/v1/bulletins/subscribe", {
				bulletin_ids: bulletinIds,
			});
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	async remove(bulletinId: BulletinGroup["id"]) {
		try {
			const res = await axios.delete(`/api/v1/bulletins/${bulletinId}`);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const bulletinService = Object.freeze(new BulletinService());
